// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (i18n: any, admin: any) => [
  {
    icon: 'mdi-view-dashboard',
    text: i18n.t('menu.dashboard'),
    link: '/',
  },
  { divider: true },
  { heading: i18n.t('menu.content') },
  admin.getResourceLink('books'),
  admin.getResourceLink('articles'),
  admin.getResourceLink('videos'),
  admin.getResourceLink('audio-fragments'),
  admin.getResourceLink('content-image'),
  {
    icon: 'mdi-library',
    text: 'Collections',
    children: [admin.getResourceLink('collections'), admin.getResourceLink('views')],
  },
  {
    icon: 'mdi-database',
    text: i18n.t('menu.ref_data'),
    children: [
      admin.getResourceLink('categories'),
      admin.getResourceLink('publishers'),
      admin.getResourceLink('languages'),
      admin.getResourceLink('series'),
      admin.getResourceLink('areas'),
      admin.getResourceLink('keywords'),
      admin.getResourceLink('contributors'),
    ],
  },
  { divider: true },
  { heading: i18n.t('menu.giglets') },
  {
    icon: 'mdi-book-open-blank-variant',
    text: 'Giglets',
    children: [admin.getResourceLink('giglets-books')],
  },
  { divider: true },
  { heading: i18n.t('menu.polylino') },
  {
    icon: 'mdi-format-paragraph',
    text: 'Polylino',
    children: [admin.getResourceLink('book-talk'), admin.getResourceLink('reading-competitions')],
  },
  { divider: true },
  { heading: 'Manabua' },
  {
    icon: 'mdi-movie-edit-outline',
    text: 'Manabua',
    children: [
      {
        icon: 'mdi-star',
        text: 'Featured Videos',
        link: '/manabua/featured-videos',
      },
      {
        icon: 'mdi-star',
        text: 'Featured Articles',
        link: '/manabua/featured-articles',
      },
      {
        icon: 'mdi-book-open-variant-outline',
        text: 'Epub Guide Generator',
        link: '/manabua/epub-guide-generator',
      },
    ],
  },
  { heading: i18n.t('menu.common') },
  admin.getResourceLink('exercises'),
  admin.getResourceLink('materials'),
  admin.getResourceLink('translations'),
  {
    icon: 'mdi-book-plus',
    text: 'The Publisher',
    link: '/the-publisher',
  },
  {
    icon: 'mdi-file-document-plus',
    text: 'The Article Publisher',
    link: '/the-article-publisher',
  },
  { divider: true },
  { heading: i18n.t('menu.scopes') },
  admin.getResourceLink('scopes'),
];
